import styled from "styled-components";

export const PageDivider = styled.hr`
  border: none;
  border-top: 1px solid ${({ theme }) => theme.color.border.default};
  margin: 0;
  padding: 0;
`;
